interface AttachmentFileModelScope extends ng.IScope {
  clearAttachment : () => void;
  handleFileChange: () => void;
  progress        : number;
}

export function AttachmentFileModelDirective (
  $parse: ng.IParseService
) : ng.IDirective {
  const directive : ng.IDirective = {
    restrict: 'A',
    link    (
      scope  : AttachmentFileModelScope,
      element: any,
      attrs  : ng.IAttributes
    ) {
      const model       = $parse(attrs.fileModel);
      const modelSetter = model.assign;

      scope.clearAttachment = function () {
        element.val('');
        element.trigger('change');

        scope.progress = 0;
      };

      scope.handleFileChange = function () {
        const file  = element[0].files[0];

        modelSetter(scope, file);

        if (!scope.$$phase) {
          scope.$apply();
        }
      };

      element.on('change', scope.handleFileChange);

      scope.$on('$destroy', () => {
        element.off('change', scope.handleFileChange);
      });
    }
  };

  return directive;
}